export default __webpack_public_path__ + "static/6820-0153aa0ba0de15bf0f290881b2981d61.jpg";